import React from 'react';
import { Box } from '@material-ui/core';
import { useBankAccounts } from 'modules/2023-q3/banking-page/v2/hooks/use-bank-accounts';
import { BankAccount } from 'modules/2023-q3/banking-page/v2/types/bank-account';
import { Bank } from './components/bank/bank';

const groupPlaidConnections = (bankAccounts: BankAccount[]) => {
  return bankAccounts.reduce<Record<string, BankAccount[]>>(
    (groups, account) => {
      if (!groups[account.BankItemId]) {
        groups[account.BankItemId] = [];
      }

      groups[account.BankItemId].push(account);
      return groups;
    },
    {},
  );
};

export const BankAccounts = () => {
  const { data: bankAccounts } = useBankAccounts();

  const FinancialDataAggregatorPlaid = 'PLAID';

  const plaidBankAccounts =
    bankAccounts?.filter(
      (bankAccount) =>
        bankAccount.FinancialDataAggregator === FinancialDataAggregatorPlaid,
    ) || [];
  const plaidConnections = groupPlaidConnections(plaidBankAccounts);

  const manuallyAddedBankAccounts = bankAccounts?.filter(
    (bankAccount) =>
      bankAccount.FinancialDataAggregator !== FinancialDataAggregatorPlaid,
  );

  return (
    <>
      {Object.entries(plaidConnections).map(([bankItemId, accounts]) => (
        <Box key={bankItemId} mb={10}>
          <Bank
            bankAccounts={accounts.sort(
              (a, b) => Number(a.Mask) - Number(b.Mask),
            )}
            bankItemId={bankItemId}
            institution={accounts[0]?.institution?.name}
          />
        </Box>
      ))}

      {manuallyAddedBankAccounts && manuallyAddedBankAccounts?.length > 0 && (
        <Bank bankAccounts={manuallyAddedBankAccounts} manual />
      )}
    </>
  );
};
